function Navbar () {
    return (
        <div className="navbar">
            <div className="logo">Citadel Office Olympics Trivia</div>
        </div>
    )
}

export default Navbar;